<template>
  <div class="wrap">
    <nav class="navbar navbar-froDesk">
      <div class="navbar-div">
        <ul class="nav justify-content-around">
          <li class="nav-item" v-for="item in navList" :key="item.id" @click="handleChangePage(item)">
            <a class="nav-link" :class="item.url==nowNavId?'active':''">{{item.name}}</a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nowNavId: "/index",
      navList: [
        { id: 0, name: "首页", url: "/index" },
        { id: 1, name: "科研动态", url: "/researchDynamics" },
        { id: 2, name: "课题研究", url: "/subjectResearch" },
        { id: 3, name: "科研成果", url: "/researchResults" },
        { id: 4, name: "项目管理", url: "/projectManagement" },
        { id: 5, name: "科研资源", url: "/researchResources" },
      ],
    };
  },
  //监听路由变化
  watch: {
    $route: {
      handler() {
        this.nowNavId = this.$route.path;
      },
      deep: true,
    },
  },
  mounted() {
    this.nowNavId = this.$route.path;
  },
  methods: {
    handleChangePage(item) {
      if (item.url == this.nowNavId || !item.url) return;
      this.$router.push(item.url);
    },
  },
};
</script>
<style lang="scss" scoped>
.navbar-froDesk {
  background-color: #5172c5;
}
.navbar-froDesk .navbar-div {
  margin: 0 auto;
  padding: 0 15px;
  width: 1200px;
}
.navbar-froDesk .nav {
  margin: 0 auto;
  max-width: 1200px;
  text-align: left;
}
.navbar-froDesk .nav-item {
  margin: 0 5px;
  width: 160px;
  text-align: center;
  cursor: pointer;
}
.navbar-froDesk .nav-link {
  font-size: 16px;
  color: #fff;
  border: 1px solid transparent;
  border-radius: 5px;
}
.navbar-froDesk .nav-link:hover {
  border: 1px solid #fff;
  color: #fff;
}
.navbar-froDesk .active,
.navbar-froDesk .active:hover {
  background-color: rgb(255, 255, 255);
  border: 1px solid transparent;
  border-radius: 5px;
  color: #5172c5;
}
</style>
